export default class WYSIWYG {
  constructor() {
    this.$header = document.querySelector('.js-header');
    this.$tableOfContentsLinks = document.querySelectorAll('.js-toc-link');
    this.$tableOfContentsLinks.forEach($link => {
      $link.addEventListener('click', (e) => {
        e.preventDefault();
        this.onTableOfContentsLinkClick($link)
      });
    });
  }

  onTableOfContentsLinkClick($link) {
    const offset = this.$header.offsetHeight;
    const gap = 20;

    window.scrollTo({
      behavior: 'smooth',
      top:
        document.querySelector($link.getAttribute("href")).getBoundingClientRect().top -
        document.body.getBoundingClientRect().top -
        offset - gap,
    })
  }
}
